module.exports = __webpack_public_path__ + "img/full4-min.f7fbd3b6.png";